export enum AccountActivationStatus {
    Activating,
    Activated,
    Failure
}